import React from "react";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            {props.data ? <img src={props.data.color} alt="회사로고" /> : "Loading"}
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#introduction" className="page-scroll">
                데이터 소개
              </a>
            </li>
            <li>
              <a href="#service" className="page-scroll">
                API 서비스
              </a>
            </li>
            <li>
              <a href="#map" className="page-scroll">
                데이터 가시화
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                문의
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
